import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { resetResonanceProject, selectResonanceTab } from '../redux/resonance/resonanceReducer';
import { getResonanceInitData, getResonanceProjectInfo } from '../redux/resonance/resonanceActions';
import MessageResponse from './components/message-response/MessageResponse';
import Benchmarks from './components/benchmarks/Benchmarks';
import CommonPage from '../components/common-page/CommonPage';
import CommonTabs from '../components/common-tabs/CommonTabs';
import CommonTabPanel from '../components/common-tabs/CommonTabPanel';
import ConceptResponse from './components/concept-response/ConceptResponse';
import useResonanceTabs from './hooks/useResonanceTabs';
import BackgroundData from './components/background-data/BackgroundData';

import scss from './Resonance.module.scss';

function Resonance() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const selectedTab = useSelector((state) => state.resonance.selectedTab);

  const TABS = useResonanceTabs();

  const handleChangeTab = (_, newTab) => {
    dispatch(selectResonanceTab(newTab));
  };

  useEffect(() => {
    if (id) {
      dispatch(getResonanceInitData(id));
      dispatch(getResonanceProjectInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetResonanceProject());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <CommonPage className={scss.pageWrapper}>
      <CommonTabs tabs={TABS} value={selectedTab} onChange={handleChangeTab} isFullWidth />

      <CommonTabPanel value={selectedTab} index={0}>
        <BackgroundData />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={1}>
        <MessageResponse />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={2}>
        <ConceptResponse />
      </CommonTabPanel>

      <CommonTabPanel value={selectedTab} index={3}>
        <Benchmarks />
      </CommonTabPanel>
    </CommonPage>
  );
}

export default Resonance;
